export const stages = ["PENDING_DELIVERY", "DELIVERED"];

export const stageNames = {
  PENDING_DELIVERY: "Premios Recibidos",
  DELIVERED: "Premios Entregados",
};

export const stagePlaceholder = {
  PENDING_DELIVERY: "Aquí verás nuevos premios de tus clientes.",
  DELIVERED: "Una vez entregado el premio, arrástralo a esta columna.",
};

export const stageChoices = stages.map((type) => ({
  id: type,
  name: stageNames[type],
}));
